var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    viewBox: "0 0 100 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_6976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1155 52.7496L66.6678 0H33.3331L63.7831 52.7496H97.1155ZM30.4459 5.00215L0 57.7472L16.6678 86.6208L47.1133 33.8745L30.4459 5.00215ZM39.1095 57.7472L22.4438 86.6208H83.3331L100 57.7472L39.1095 57.7472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_6976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 86.6208,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.b9cfabf7ab8219758b07dbe1be600a28.svg";
export { ForwardRef as ReactComponent };